var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockClosedGray = function SvgLockClosedGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    fillRule: "evenodd",
    d: "M8.25 1a3.5 3.5 0 0 0-3.5 3.5V7a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5V4.5A3.5 3.5 0 0 0 8.25 1m2 6V4.5a2 2 0 1 0-4 0V7z",
    clipRule: "evenodd"
  })));
};
export { SvgLockClosedGray as ReactComponent };
export default __webpack_public_path__ + "8ec07f5836e635e2b236c0f9f1057817.svg";